import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService } from '../../modules/authentication/services/auth.service';
import { CommonService } from '../../services/common.service';
import { ApiUser } from 'src/app/model/user';

@Component({
  selector: 'vrm-login-with-v2token',
  templateUrl: './login-with-v2token.component.html',
  styleUrls: ['./login-with-v2token.component.scss'],
})
export class LoginWithV2tokenComponent implements OnInit {
  token: string;
  ssoFailed: boolean = false;
  signInDone: boolean = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    public cService: CommonService
  ) {}

  ngOnInit() {
    this.authService.quickLogout(true, () => {
      this.activatedRoute.queryParams.subscribe({
        next: (params: { token: string }) => {
          this.token = params.token;
          console.log('v2 Token', this.token);

          if (this.token) {
            this.cService.showToast('Logging in...');
            this.authService.v2TokenLogin(this.token).subscribe({
              next: (response) => {
                this.goToDefaultPage(response.startPage, () => {
                  this.cService.reloadAndTryToApplyUpdates();
                });
              },

              error: (error) => {
                this.loginFailed();
              },
            });
          } else {
            this.loginFailed();
            console.error(':: VRM ERROR: Token cannot be empty');
          }
        },
      });
    });

    setTimeout(() => {
      this.cService.hideIndeterminateProgress = true;
    });
  }

  loginFailed() {
    this.ssoFailed = true;
    this.cService.showToast(':: Unable to process login');
  }

  goToDefaultPage(startPage: string, navCallback?: () => void) {
    if (startPage) {
      this.cService.appSettings.defaultPage = startPage;
    }

    this.router.navigate([this.cService.appSettings.defaultPage]).then(() => {
      if (navCallback) {
        navCallback();
      }
    });

    if (!this.ssoFailed) {
      this.signInDone = true;
    }
  }
}
